export { alertVariables as alertDismissActionVariables } from './alertVariables';
